import { render, staticRenderFns } from "./EnrollmentSuccessDialog.vue?vue&type=template&id=5fa049ae&scoped=true&"
import script from "./EnrollmentSuccessDialog.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentSuccessDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollmentSuccessDialog.vue?vue&type=style&index=0&id=5fa049ae&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa049ae",
  null
  
)

export default component.exports